import * as React from 'react';

export interface LoadingSpinnerProps {
}

export class LoadingSpinner extends React.Component<LoadingSpinnerProps> {
  public render() {
    return (
      <div className="loading-screen-partial">
        <div className="loading-screen">
          <div className="lds-ring"><div /><div /><div /><div /></div>
        </div>
      </div>
    );
  }
}

export default LoadingSpinner;
